'use client';

import { c as _c } from "react/compiler-runtime";
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check, Minus } from 'lucide-react';
import * as React from 'react';
import { cn } from '@/lib/utils';
const Checkbox = t0 => {
  const $ = _c(19);
  let checked;
  let className;
  let props;
  let ref;
  let t1;
  if ($[0] !== t0) {
    ({
      ref,
      className,
      variant: t1,
      checked,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = checked;
    $[2] = className;
    $[3] = props;
    $[4] = ref;
    $[5] = t1;
  } else {
    checked = $[1];
    className = $[2];
    props = $[3];
    ref = $[4];
    t1 = $[5];
  }
  const variant = t1 === undefined ? "light" : t1;
  const t2 = variant === "dark" && "!bg-background";
  let t3;
  if ($[6] !== className || $[7] !== t2) {
    t3 = cn("peer h-4 w-4 shrink-0 rounded-sm border border-zinc-400 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground", t2, className);
    $[6] = className;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn("flex items-center justify-center text-current");
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== checked || $[11] !== variant) {
    t5 = <CheckboxPrimitive.Indicator className={t4}>{checked === "indeterminate" ? <Minus className={cn("size-4", variant === "dark" && "!text-foreground")} /> : <Check className={cn("size-4", variant === "dark" && "!text-foreground")} />}</CheckboxPrimitive.Indicator>;
    $[10] = checked;
    $[11] = variant;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== checked || $[14] !== props || $[15] !== ref || $[16] !== t3 || $[17] !== t5) {
    t6 = <CheckboxPrimitive.Root ref={ref} className={t3} checked={checked} {...props}>{t5}</CheckboxPrimitive.Root>;
    $[13] = checked;
    $[14] = props;
    $[15] = ref;
    $[16] = t3;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};
Checkbox.displayName = CheckboxPrimitive.Root.displayName;
export { Checkbox };